var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "文章标题", prop: "newsTitle" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入文章标题" },
                    model: {
                      value: _vm.form.newsTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newsTitle", $$v)
                      },
                      expression: "form.newsTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属比赛", prop: "contest" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择文章类别" },
                      model: {
                        value: _vm.form.contest,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contest", $$v)
                        },
                        expression: "form.contest",
                      },
                    },
                    _vm._l(_vm.contestTypeList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "文章排序", prop: "sort" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "层次", prop: "courseLevel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择层次" },
                      model: {
                        value: _vm.form.courseLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseLevel", $$v)
                        },
                        expression: "form.courseLevel",
                      },
                    },
                    _vm._l(_vm.courseLevelList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "年份", prop: "year" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择年份" },
                      model: {
                        value: _vm.form.year,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "year", $$v)
                        },
                        expression: "form.year",
                      },
                    },
                    _vm._l(_vm.yearList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "比赛类型", prop: "contestType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择比赛类型" },
                      model: {
                        value: _vm.form.contestType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contestType", $$v)
                        },
                        expression: "form.contestType",
                      },
                    },
                    _vm._l(_vm.coTypeList, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.name, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "文章内容：", prop: "newsSummary" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请输入文章内容" },
                    model: {
                      value: _vm.form.newsSummary,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newsSummary", $$v)
                      },
                      expression: "form.newsSummary",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }